import pathfinder from '@fiverr-private/pathfinder';
import topLevelSourceStorage from '../../storage/topLevelSource';
import checkDeliveryReady from '../checkDeliveryReady';
import createOrder from '../../api/order/create';
import saveEnrichmentByPaymentSession from '../../api/order/saveEnrichmentByPaymentSession';
import { ORDER_CREATION_REDIRECTS } from './const';

const initPackagePurchaseSession = async ({
    projectId,
    variationId,
    packageType,
    source,
    brandName,
    slogan,
    refCtxId,
    mixpanelEnrichment,
    metricsReporter,
}) => {
    const topLevelSource = topLevelSourceStorage.getTopLevelSourceFromStorage();

    const { redirect, redirectId, contextId } = await createOrder({
        projectId,
        variationId,
        packageType,
        source,
        brandName,
        slogan,
        topLevelSource,
    });

    topLevelSourceStorage.clearTopLevelSourceFromStorage();

    switch (redirect) {
        case ORDER_CREATION_REDIRECTS.POST_ORDER_PAGE:
            const metricsCancelListener = () => metricsReporter?.count('delivery_ready_polling.canceled');
            window.addEventListener('beforeunload', metricsCancelListener);

            const isReady = await checkDeliveryReady(contextId);

            window.removeEventListener('beforeunload', metricsCancelListener);

            if (!isReady) {
                metricsReporter?.count('delivery_ready_polling.timeout');
                return isReady;
            }

            metricsReporter?.count('delivery_ready_polling.success');

            window.location = pathfinder(
                'logo_maker_post_order_page',
                { order_id: contextId || redirectId },
                { query: { ref_ctx_id: refCtxId } }
            );

            return isReady;

        case ORDER_CREATION_REDIRECTS.CHECKOUT_PAGE:
        default:
            await saveEnrichmentByPaymentSession({ paymentSessionId: redirectId, mixpanelEnrichment });
            window.location = pathfinder(
                'payments_page',
                {},
                { query: { paymentSessionID: redirectId, ref_ctx_id: refCtxId } }
            );
            return true;
    }
};

export default initPackagePurchaseSession;
